<template>
  <div class="popupDiv" @click.self="CancelClose">
    <div class="popupContainer" v-show="firstPopup">
      <div class="popupHeader">
        Sign Out
        <img src="@/assets/icon/notice_close@2x.png" @click="CancelClose" />
      </div>
      <div class="popupBody">
        Welcome to FlipAIoT!
        <br />
        Do you want to log out or continue to use FlipAIoT?
      </div>
      <div class="popupFooter">
        <div class="FooterBtn FooterBtnCancel" @click="toSecondPop">Sign out</div>
        <div class="FooterBtn" @click="CancelClose">Coutinue to use</div>
      </div>
    </div>
    <div class="popupContainer" v-show="secondPopup">
      <div class="popupHeader">
        Sign Out
        <img src="@/assets/icon/notice_close@2x.png" @click="CancelClose" />
      </div>
      <div class="popupBody">
        Friendly notice: save the files of code and trained model before logging out!
        <br />
        Are you sure to log out?
      </div>
      <div class="popupFooter">
        <div class="FooterBtn FooterBtnCancel" @click="CancelClose">Cancel</div>
        <div class="FooterBtn" @click="logoutProcess">Sign out</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      firstPopup: true,
      secondPopup: false,
    };
  },
  methods: {
    CancelClose() {
      this.$emit('CancelClose');
    },
    toSecondPop() {
      this.firstPopup = false;
      this.secondPopup = true;
    },
    logoutProcess() {
      console.log('start logout progress');
      this.$emit('logoutProcess');
    },
  },
};
</script>

<style lang="scss" scoped>
.popupDiv {
  z-index: 1000;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  .popupContainer {
    animation: popup 0.3s;
    width: 380px;
    height: 185px;
    background-color: #f3f5f9;
    border-radius: 10px;
    position: relative;
    .popupHeader {
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      height: 35px;
      border-radius: 10px 10px 0 0;
      font-size: 13px;
      line-height: 35px;
      color: #282828;
      img {
        position: absolute;
        right: 8px;
        top: 8px;
        height: 16px;
        cursor: pointer;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    .popupBody {
      font-size: 14px;
      text-align: left;
      color: #282828;
      padding: 20px;
      line-height: 20px;
    }
    .popupFooter {
      width: 100%;
      height: 36px;
      position: absolute;
      bottom: 32px;
      display: flex;
      .FooterBtn {
        width: 50%;
        font-size: 20px;
        line-height: 36px;
        color: #f3f5f9;
        cursor: pointer;
        background-color: #37ccda;
        &:hover {
          background-color: #23b6bc;
        }
      }
      .FooterBtnCancel {
        background-color: #9b9c9e;
        color: #282828;
        &:hover {
          background-color: #c6c8cb;
        }
      }
    }
  }
}
@keyframes popup {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  70% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>
